// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/videos/bg-video.mp4", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/icons/bg-vector.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-bgvideo {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
.main-bgvideo-button {
  position: absolute;
  left: 64px;
  bottom: 40px;
  padding: 20px;
  box-sizing: border-box;
  width: 500px;
  height: 110px;
  border-radius: 16px;
  background-color: rgba(43, 42, 41, 0.6980392157);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.main-bgvideo-button-left {
  display: flex;
  align-items: center;
}
.main-bgvideo-button-left-img {
  width: 70px;
  height: 70px;
  border-radius: 6px;
  margin-right: 20px;
  border: 1px solid rgba(67, 66, 66, 0.4);
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-bgvideo-button-left-img img {
  width: 42px;
  height: 57px;
  object-fit: contain;
}
.main-bgvideo-button-left-text {
  font-size: 14px;
  font-weight: 500;
  color: #fefefe;
}
.main-bgvideo-button-left-text span {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
}
.main-bgvideo-button button {
  padding: 12px 24px;
  border-radius: 20px;
  border: 0;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #6E00FF;
  cursor: pointer;
}
.main-bgvideo-button button span {
  font-size: 16px;
  font-weight: 500;
  color: #fefefe;
  margin-right: 10px;
}
.main-slider {
  width: 100%;
  padding: 100px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
}
.main-slider-title {
  font-size: 32px;
  font-weight: 700;
  color: #fefefe;
  text-align: center;
}
.main-slider-descr {
  margin-top: 16px;
  font-size: 14px;
  font-weight: 400;
  color: #898989;
  text-align: center;
}
.main-slider::after {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: -1;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.main-slider-categories {
  width: 100%;
  padding: 100px 0;
  box-sizing: border-box;
}
.main-slider-categories-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.main-slider-categories-row-item {
  border-radius: 12px;
  position: relative;
  cursor: pointer;
}
.main-slider-categories-row-item img {
  border-radius: 12px;
  object-fit: cover;
}
.main-slider-categories-row-item-name {
  position: absolute;
  bottom: 24px;
  left: 30px;
  font-size: 20px;
  font-weight: 500;
  color: #fefefe;
}
.main-slider-categories-row-block {
  width: 50%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.main-slider-categories-row-block-item {
  width: 49%;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
}
.main-slider-categories-row-block-item img {
  border-radius: 12px;
  object-fit: cover;
}
.main-slider-categories-row-block-item-name {
  position: absolute;
  bottom: 24px;
  left: 30px;
  font-size: 20px;
  font-weight: 500;
  color: #fefefe;
}
.main-slider-categories-row-block-item:nth-child(3) {
  margin-top: 10px;
}
.main-slider-categories-row-block-item:nth-child(4) {
  margin-top: 10px;
}
.main-slider-categories-row:last-child {
  margin-top: 30px;
}

@media (max-width: 1024px) {
  .main-bgvideo-button {
    width: 450px;
    height: 90px;
    left: 30px;
    bottom: 20px;
  }
  .main-bgvideo-button-left-img {
    width: 60px;
    height: 60px;
  }
  .main-bgvideo-button-left-img img {
    width: 38px;
    height: 50px;
  }
  .main-bgvideo-button button {
    padding: 8px 18px;
  }
  .main-bgvideo-button button span {
    font-size: 14px;
  }
  .main-bgvideo-button button span svg {
    width: 14px;
    height: 15px;
  }
  .main-slider {
    padding: 60px 0;
  }
  .main-slider-title {
    font-size: 26px;
  }
  .main-slider-descr {
    max-width: 500px;
    margin: 10px auto;
  }
}
@media (max-width: 576px) {
  .main-bgvideo-button {
    width: 400px;
    height: 70px;
    left: 10px;
  }
  .main-bgvideo-button-left-text {
    font-size: 12px;
  }
  .main-bgvideo-button-left-img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
  .main-bgvideo-button button {
    padding: 8px 12px;
  }
  .main-bgvideo-button button span {
    font-size: 12px;
    margin-right: 5px;
  }
  .main-bgvideo-button button svg {
    width: 12px;
  }
  .main-slider-title {
    font-size: 18px;
  }
  .main-slider-descr {
    font-size: 12px;
    max-width: 400px;
  }
  .main-slider-categories-row {
    align-items: center;
    flex-direction: column;
  }
  .main-slider-categories-row-block {
    width: 100% !important;
    flex-direction: column;
  }
  .main-slider-categories-row-block .main-slider-categories-row-item {
    width: 100% !important;
  }
  .main-slider-categories-row-item {
    width: 100% !important;
    margin-top: 10px;
  }
  .main-slider-categories-row-item img {
    width: 100%;
  }
  .main-slider-categories-row-item-name {
    font-size: 16px;
    left: 15px;
  }
  .main-slider-categories-row:last-child {
    margin-top: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/MainPage/style.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;AAAJ;AACI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gDAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACN;AAAM;EACE,aAAA;EACA,mBAAA;AAER;AADQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,uCAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGV;AAFU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAIZ;AADQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAGV;AAFU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAIZ;AAAM;EACE,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;AAER;AADQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAGV;AAEE;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAAJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACN;AACI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACN;AACI;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,gDAAA;AACN;AACI;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;AACN;AAAM;EACE,WAAA;EACA,aAAA;EACA,8BAAA;AAER;AADQ;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;AAGV;AAFU;EACE,mBAAA;EAEA,iBAAA;AAGZ;AADU;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAGZ;AAAQ;EACE,UAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AAEV;AADU;EACE,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAGZ;AAFY;EACE,mBAAA;EAEA,iBAAA;AAGd;AADY;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAGd;AADY;EACE,gBAAA;AAGd;AADY;EACE,gBAAA;AAGd;AACQ;EACE,gBAAA;AACV;;AAMA;EAGM;IACE,YAAA;IACA,YAAA;IACA,UAAA;IACA,YAAA;EALN;EAOQ;IACE,WAAA;IACA,YAAA;EALV;EAMU;IACE,WAAA;IACA,YAAA;EAJZ;EAQM;IACE,iBAAA;EANR;EAOQ;IACE,eAAA;EALV;EAMU;IACE,WAAA;IACA,YAAA;EAJZ;EAUE;IACE,eAAA;EARJ;EASI;IACE,eAAA;EAPN;EASI;IACE,gBAAA;IACA,iBAAA;EAPN;AACF;AAYA;EAGM;IACE,YAAA;IACA,YAAA;IACA,UAAA;EAZN;EAcQ;IACE,eAAA;EAZV;EAcQ;IACE,WAAA;IACA,YAAA;IACA,kBAAA;EAZV;EAeM;IACE,iBAAA;EAbR;EAcQ;IACE,eAAA;IACA,iBAAA;EAZV;EAcQ;IACE,WAAA;EAZV;EAkBI;IACE,eAAA;EAhBN;EAkBI;IACE,eAAA;IACA,gBAAA;EAhBN;EAmBM;IACE,mBAAA;IACA,sBAAA;EAjBR;EAkBQ;IACE,sBAAA;IACA,sBAAA;EAhBV;EAiBU;IACE,sBAAA;EAfZ;EAkBQ;IACE,sBAAA;IACA,gBAAA;EAhBV;EAiBU;IACE,WAAA;EAfZ;EAiBU;IACE,eAAA;IACA,UAAA;EAfZ;EAkBQ;IACE,aAAA;EAhBV;AACF","sourcesContent":[".main {\n  &-bgvideo {\n    width: 100%;\n    height: 100vh;\n    box-sizing: border-box;\n    background-image: url(\"~/public/videos/bg-video.mp4\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    position: relative;\n    &-button {\n      position: absolute;\n      left: 64px;\n      bottom: 40px;\n      padding: 20px;\n      box-sizing: border-box;\n      width: 500px;\n      height: 110px;\n      border-radius: 16px;\n      background-color: #2b2a29b2;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      &-left {\n        display: flex;\n        align-items: center;\n        &-img {\n          width: 70px;\n          height: 70px;\n          border-radius: 6px;\n          margin-right: 20px;\n          border: 1px solid #43424266;\n          background-color: #00000033;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          & img {\n            width: 42px;\n            height: 57px;\n            object-fit: contain;\n          }\n        }\n        &-text {\n          font-size: 14px;\n          font-weight: 500;\n          color: #fefefe;\n          & span {\n            font-size: 16px;\n            font-weight: 700;\n            color: #ffffff;\n          }\n        }\n      }\n      & button {\n        padding: 12px 24px;\n        border-radius: 20px;\n        border: 0;\n        outline: none;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: #6E00FF;\n        cursor: pointer;\n        & span {\n          font-size: 16px;\n          font-weight: 500;\n          color: #fefefe;\n          margin-right: 10px;\n        }\n      }\n    }\n  }\n  &-slider {\n    width: 100%;\n    padding: 100px 0;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    &-title {\n      font-size: 32px;\n      font-weight: 700;\n      color: #fefefe;\n      text-align: center;\n    }\n    &-descr {\n      margin-top: 16px;\n      font-size: 14px;\n      font-weight: 400;\n      color: #898989;\n      text-align: center;\n    }\n    &::after {\n      position: absolute;\n      top: 50%;\n      right: 0;\n      transform: translateY(-50%);\n      z-index: -1;\n      content: url(\"../../assets/icons/bg-vector.svg\");\n    }\n    &-categories {\n      width: 100%;\n      padding: 100px 0;\n      box-sizing: border-box;\n      &-row {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        &-item {\n          border-radius: 12px;\n          position: relative;\n          cursor: pointer;\n          & img {\n            border-radius: 12px;\n            // height: 100%;\n            object-fit: cover;\n          }\n          &-name {\n            position: absolute;\n            bottom: 24px;\n            left: 30px;\n            font-size: 20px;\n            font-weight: 500;\n            color: #fefefe;\n          }\n        }\n        &-block {\n          width: 50%;\n          display: flex;\n          justify-content: space-between;\n          flex-wrap: wrap;\n          &-item {\n            width: 49%;\n            border-radius: 12px;\n            position: relative;\n            cursor: pointer;\n            & img {\n              border-radius: 12px;\n              // height: 100%;\n              object-fit: cover;\n            }\n            &-name {\n              position: absolute;\n              bottom: 24px;\n              left: 30px;\n              font-size: 20px;\n              font-weight: 500;\n              color: #fefefe;\n            }\n            &:nth-child(3) {\n              margin-top: 10px;\n            }\n            &:nth-child(4) {\n              margin-top: 10px;\n            }\n          }\n        }\n        &:last-child {\n          margin-top: 30px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1024px) {\n  .main {\n    &-bgvideo {\n      &-button {\n        width: 450px;\n        height: 90px;\n        left: 30px;\n        bottom: 20px;\n        &-left {\n          &-img {\n            width: 60px;\n            height: 60px;\n            & img {\n              width: 38px;\n              height: 50px;\n            }\n          }\n        }\n        & button {\n          padding: 8px 18px;\n          & span {\n            font-size: 14px;\n            & svg {\n              width: 14px;\n              height: 15px;\n            }\n          }\n        }\n      }\n    }\n    &-slider {\n      padding: 60px 0;\n      &-title {\n        font-size: 26px;\n      }\n      &-descr {\n        max-width: 500px;\n        margin: 10px auto;\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .main {\n    &-bgvideo {\n      &-button {\n        width: 400px;\n        height: 70px;\n        left: 10px;\n        &-left {\n          &-text {\n            font-size: 12px;\n          }\n          &-img {\n            width: 40px;\n            height: 40px;\n            margin-right: 10px;\n          }\n        }\n        & button {\n          padding: 8px 12px;\n          & span {\n            font-size: 12px;\n            margin-right: 5px;\n          }\n          & svg {\n            width: 12px;\n          }\n        }\n      }\n    }\n    &-slider {\n      &-title {\n        font-size: 18px;\n      }\n      &-descr {\n        font-size: 12px;\n        max-width: 400px;\n      }\n      &-categories {\n        &-row {\n          align-items: center;\n          flex-direction: column;\n          &-block {\n            width: 100% !important;\n            flex-direction: column;\n            & .main-slider-categories-row-item {\n              width: 100% !important;\n            }\n          }\n          &-item {\n            width: 100% !important;\n            margin-top: 10px;\n            & img {\n              width: 100%;\n            }\n            &-name {\n              font-size: 16px;\n              left: 15px;\n            }\n          }\n          &:last-child {\n            margin-top: 0;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
